import {VetologyBase} from "../Vetology/VetologyBase";

export class EditClinic extends VetologyBase
{
    constructor()
    {
        super('EditClinic');
    }

    init()
    {
        const _self = this;
        _self.initEventHandlers();
        const aiReportsEligibleChecked = document.querySelector("input[name='ai_reports_eligible'][checked]");
        _self.setGenerateAiReportsLocked(aiReportsEligibleChecked?.value === '0');

	    const customLogoMarkup = document.querySelector(".custom-logo-markup");
	    const customLogoEnabledSwitch = document.querySelector("input[name='enableCustomLogo'][checked]");
	    const customLogoEnabled = customLogoEnabledSwitch.value === '1';


	    if (customLogoEnabled) {
		    _self.placeMarkupBeforeImage(customLogoMarkup);
		    customLogoMarkup.classList.remove('hidden');
	    }
    }

    initEventHandlers()
    {
        const _self = this;

        _self.onHtmlTextareaBlur = _self.onHtmlTextareaBlur.bind(_self);
        _self.onRadioSameAsPhysicalAddressClicked = _self.onRadioSameAsPhysicalAddressClicked.bind(_self);
        _self.onAiReportsEligibleClick = _self.onAiReportsEligibleClick.bind(_self);

        const form = document.querySelector('form.edit-clinic');
        if (form) {
            const customLogoSwitch = form.querySelectorAll('input[name="enableCustomLogo"]');
            customLogoSwitch.forEach((inputElem) => {
                inputElem.closest('label').addEventListener('click', (event) => { _self.onEnableCustomLogoClick(event) });
            });
            this.addEventListenByEnablePartnerList(form, ['enableVetrocket', 'enableDaySmart', 'enableEzyVet', 'enableHappyDoc']);

            form.querySelectorAll('input[name="ai_reports_eligible"]').forEach((inputElem) => {
                inputElem.closest('label').addEventListener('click', _self.onAiReportsEligibleClick);
            });

            const htmlTextArea = document.querySelector('textarea.custom-html');
            htmlTextArea.addEventListener('blur', _self.onHtmlTextareaBlur);

            const billingSameAsPhysicalAddressGroup = form.querySelector('div.btn-group.same-as-physical-address');
            if (billingSameAsPhysicalAddressGroup) {
                billingSameAsPhysicalAddressGroup.addEventListener('click', _self.onRadioSameAsPhysicalAddressClicked);
            }
        }
    }

	removeEventHandlers()
	{
		const _self = this;
		const form = document.querySelector('form.edit-clinic');
		if (form) {
			const customLogoSwitch = form.querySelectorAll('input[name="enableCustomLogo"]');
			customLogoSwitch.forEach((inputElem) => {
				inputElem.closest('label').removeEventListener('click', (event) => { _self.onEnableCustomLogoClick(event) });
			});
			this.removeEventListenByEnablePartnerList(form, ['enableVetrocket', 'enableDaySmart', 'enableEzyVet', 'enableHappyDoc']);

			const htmlTextArea = document.querySelector('textarea.custom-html');
			htmlTextArea.removeEventListener('blur', _self.onHtmlTextareaBlur);

            form.querySelectorAll('input[name="ai_reports_eligible"]').forEach((inputElem) => {
                inputElem.closest('label').removeEventListener('click', _self.onAiReportsEligibleClick);
            });
		}
	}

    onEnableCustomLogoClick(event)
    {
        const inputElem = event.target.children.namedItem('enableCustomLogo');
        const customLogoEnabled = inputElem.value === '1';
        const logoDataDiv = document.querySelector('div.custom-logo-data');

        if (customLogoEnabled) {
            logoDataDiv.classList.add('down');
        } else {
            logoDataDiv.classList.remove('down');
        }
    }

    onEnablePartnerClinicClick(event, enableName)
    {
        const enablePartner = event.target.children.namedItem(enableName);
        const dataDiv = document.querySelector('div.' + enableName);

        if (enablePartner.value !== '1') {
            dataDiv.classList.add('hidden');
        } else {
            dataDiv.classList.remove('hidden');
        }
    }

    onAiReportsEligibleClick(event) {
        const inputElem = event.currentTarget.querySelector('input[name="ai_reports_eligible"]');
        this.setGenerateAiReportsLocked(inputElem.value === '0');
    }

    // An ineligible clinic can't have AI reports switched on; ClinicsController@editClinic enforces the same on save.
    // The group is dimmed via its class, not the inputs' disabled attribute: disabled inputs aren't submitted and the
    // boolean validator would reject the missing generate_ai_reports.
    setGenerateAiReportsLocked(locked) {
        const generateInputs = document.querySelectorAll('form.edit-clinic input[name="generate_ai_reports"]');
        if (generateInputs.length === 0) {
            return;
        }
        generateInputs[0].closest('.btn-group').classList.toggle('disabled', locked);
        if (locked) {
            generateInputs.forEach((inputElem) => {
                const isNo = inputElem.value === '0';
                inputElem.checked = isNo;
                inputElem.closest('label').classList.toggle('active', isNo);
            });
        }
    }

    addEventListenByEnablePartnerList(form, enablePartnerList)
    {
        const _self = this;
        enablePartnerList.map((enablePartner)=>{
            const enablePartnerSwitch = form.querySelectorAll('input[name="' + enablePartner + '"]');
            enablePartnerSwitch.forEach((inputElem) => {
                inputElem.closest('label').addEventListener('click', (event) => { _self.onEnablePartnerClinicClick(event, enablePartner) });
            });

        });
    }

    removeEventListenByEnablePartnerList(form, enablePartnerList)
    {
        const _self = this;
        enablePartnerList.map((enablePartner)=>{
            const enablePartnerSwitch = form.querySelectorAll('input[name="' + enablePartner + '"]');
            enablePartnerSwitch.forEach((inputElem) => {
                inputElem.closest('label').removeEventListener('click', (event) => { _self.onEnablePartnerClinicClick(event, enablePartner) });
            });

        });
    }


    onHtmlTextareaBlur(event)
    {
        const html = event.target.value;
        const parser = new DOMParser();
        const htmlMarkup = parser.parseFromString(html, 'text/html');
        const errorNode = htmlMarkup.querySelector('parsererror');

        if (errorNode) {
            toastr.error('The custom html is invalid');
        } else {
            const markupContainer = document.querySelector("div.custom-logo-markup .logo-inner");
            // markupContainer.replaceChildren(htmlMarkup.childNodes);
            markupContainer.innerHTML = html;
            toastr.success('Custom HTML successfully updated');
        }
    }

    onRadioSameAsPhysicalAddressClicked(event)
    {
        const label = event.target;
        const clickedInput = label.querySelector('input');
        const billingContainer = label.closest('div.box-body');
        const fields = billingContainer.querySelectorAll('input');
        if (clickedInput.value == 1) {
            // yes, disable elements
            fields.forEach(elem => {
                elem.setAttribute('disabled', 'disabled');
            });
        } else {
            // no, enable elements
            fields.forEach(elem => {
                elem.removeAttribute('disabled');
            });
        }
    }

    placeMarkupBeforeImage(markupElement)
    {
        const logoElem = document.querySelector("img.img_GooglePlaceIDLogo");
        logoElem.parentElement.insertBefore(markupElement, logoElem);
    }
}
